/**
 * ACCOUNTS - PORTAL CENTRAL DE AUTENTICACIÓN
 * 
 * Punto único de entrada para autenticación del ecosistema.
 * NO es un producto, NO maneja permisos, NO da acceso.
 * Solo autentica y redirige.
 * 
 * @package @thefomlabs/accounts
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
// ✅ Importar directivas de Tailwind (globals.css ya incluye las variables CSS necesarias)
import './styles/globals.css';
import './styles/auth.css';
import { GlobalErrorBoundary } from '@shared/components/GlobalErrorBoundary';
import { installGlobalErrorInterceptors } from '@shared/lib/errorReporter';

const root = document.getElementById('root');
if (import.meta.env.DEV) {
  console.log('[main.tsx] Root:', root ? `#${root.id}` : null);
}
console.log('[main.tsx] Window location:', window.location.href);
console.log('[main.tsx] Window pathname:', window.location.pathname);

// 🔐 BASENAME: Configurar basename para desarrollo
// ⚠️ ARQUITECTURA: En DEV, Accounts SIEMPRE debe accederse vía proxy (localhost:5173/accounts)
// El proxy reescribe el path pero el navegador ve /accounts, así que necesitamos basename
// En PROD, accounts tiene su propio dominio y basename es '/' o '/accounts' según configuración
// Detectar modo desarrollo de forma segura
const isDevelopment = typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
const pathname = typeof window !== 'undefined' ? window.location.pathname : '';
// Detectar si estamos accediendo bajo /accounts (proxy - CORRECTO en DEV)
const isUnderProxy = pathname.startsWith('/accounts');
const basename = isDevelopment && isUnderProxy ? '/accounts' : '/';
console.log('[main.tsx] isDevelopment:', isDevelopment);
console.log('[main.tsx] pathname:', pathname);
console.log('[main.tsx] isUnderProxy:', isUnderProxy);
console.log('[main.tsx] basename:', basename);

installGlobalErrorInterceptors('accounts');

if (root) {
  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <GlobalErrorBoundary>
        <BrowserRouter basename={basename}>
          <App />
        </BrowserRouter>
      </GlobalErrorBoundary>
    </React.StrictMode>
  );
  console.log('[main.tsx] React app montado en root');
} else {
  console.error('[main.tsx] No se encontró el elemento root');
}
